export default {
    bindings: {
        icon: '@',
        large: '<'
    },
    template: require('../views/icon.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/components/icon.component.js